import { ThemeProperties } from '../../core';

export interface ToastNotificationTheme {
	basePadding: string;
	baseGap: string;
	baseBorderRadius: string;
	baseElevation: string;

	successBackground: string;
	successTextColor: string;
	successBorderColor: string;
	successIconColor: string;

	dangerBackground: string;
	dangerTextColor: string;
	dangerBorderColor: string;
	dangerIconColor: string;

	warningBackground: string;
	warningTextColor: string;
	warningBorderColor: string;
	warningIconColor: string;

	infoBackground: string;
	infoTextColor: string;
	infoBorderColor: string;
	infoIconColor: string;
}
export const theme = new ThemeProperties('toastNotification');
